/** `pluralRu` forms of the open-thread count: the chat page header and the shell «Чат» tab read the same word. */
export const OPEN_FORMS = ['нерешённый', 'нерешённых', 'нерешённых'] as const;
